import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class TicketEntryDA {
  static apiResponse: ApiResponse

  public static async getPendingTickets(
    id_company: string,
    filters: { orphanOnly?: boolean; side?: string; date_from?: string; date_to?: string }
  ): Promise<ApiResponse> {
    const params = new URLSearchParams()
    params.set('status', 'pending')
    params.set('sort_by', 'created_date')
    params.set('sort_order', 'desc')
    params.set('limit', '500')

    if (filters.orphanOnly) params.set('id_period', 'none')
    if (filters.side) params.set('side', filters.side)
    if (filters.date_from) params.set('date_from', filters.date_from)
    if (filters.date_to) params.set('date_to', filters.date_to)

    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/ticket-entries?${params.toString()}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }
}
